import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  Box,
  TextField,
} from "@mui/material";

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: (note: string, palletFlag: boolean) => void;
}

const QuickReturnDialog: React.FC<Props> = ({ open, onClose, onSubmit }) => {
  const [note, setNote] = useState("");
  const [palletFlag, setPalletFlag] = useState<boolean>(false);

  const handleSubmit = () => {
    onSubmit(note, palletFlag);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          textAlign: "center",
          fontWeight: 600,
          fontSize: "21px",
          px: 5,
        }}
      >
        Quick Return
      </DialogTitle>

      <DialogContent>
        <TextField
          fullWidth
          multiline
          required
          minRows={4}
          placeholder="Please enter any special instructions you would like to share with the branch."
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />

        <Box sx={{ mt: 3, display: "flex", alignItems: "center" }}>
          <Typography
            sx={{
              fontFamily: '"Montserrat", Verdana, sans-serif',
              fontSize: "14px",
              color: "#494440",
              mr: 2,
            }}
          >
            Was your order on a pallet?
          </Typography>

          <RadioGroup
            row
            value={palletFlag ? "yes" : "no"}
            onChange={(e) => setPalletFlag(e.target.value === "yes")}
            sx={{
              "& .MuiFormControlLabel-label": {
                fontSize: "14px",
              },
              "& .MuiRadio-root": {
                transform: "scale(0.8)",
              },
            }}
          >
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </RadioGroup>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          type="submit"
          className="blueButtonOutline"
          onClick={handleSubmit}
        >
          SUBMIT REQUEST
        </Button>
        <Button className="blueButtonOutline" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuickReturnDialog;
